/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Documents_Sort_NameInputs */

const cs_documents_sort_name = /** @type {(inputs: Documents_Sort_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Název A–Z`)
};

const en_documents_sort_name = /** @type {(inputs: Documents_Sort_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name A–Z`)
};

/**
* | output |
* | --- |
* | "Name A–Z" |
*
* @param {Documents_Sort_NameInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_sort_name = /** @type {((inputs?: Documents_Sort_NameInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Sort_NameInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_documents_sort_name(inputs)
	return cs_documents_sort_name(inputs)
});